export const repositoryUrl = "https://github.com/xdward/mini-dafny";
